import script from "./NewbookPaymentLinkModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewbookPaymentLinkModal.vue?vue&type=script&setup=true&lang=ts"

import "./NewbookPaymentLinkModal.vue?vue&type=style&index=0&id=030efb51&scoped=true&lang=css"

import exportComponent from "/var/www/zioncallmanagement.com/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-030efb51"]])

export default __exports__